"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeywordSearchResultsContent = void 0;
exports.KeywordSearchResultsContent = {
  en: {
    featuresText: "Features",
    artliclesText: "Articles & Resources"
  },
  fr: {
    featuresText: "Caractéristiques",
    artliclesText: "Articles et ressources"
  },
  es: {
    featuresText: "Características",
    artliclesText: "Artículos y recursos"
  }
};